import React, { useState, useContext } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Typography,
  Box,
  Tooltip,
  Divider,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Close,
  Menu as MenuIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material";
import SidebarContext from "./sidebarcontext/SidebarContext";
import AuthContext from "./auth-context";

export default function Uppersidebar() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const authCtx = useContext(AuthContext);
  const { menutoggle, setMenutoggle, setAlert } = useContext(SidebarContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const userinfo = JSON.parse(localStorage.getItem("userInfo"));
  const { coOperativeName, coOperativeAddress, coOperativeCode, coOperativeImg } = userinfo || {};

  const handleSidebarToggle = () => setMenutoggle(!menutoggle);
  const refresh = () => window.location.reload();

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogoutClick = () => {
    handleMenuClose();
    setAlert({
      fade: "fade-in",
      msg: "Do you want to Logout?",
      type: "logout",
    });
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        top: 0,
        backgroundColor: "white",
        color: "text.primary",
        boxShadow: "none",
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Toolbar>
        {/* Sidebar toggle */}
        <Tooltip title={menutoggle ? "Open menu" : "Close menu"} arrow>
          <IconButton
            edge="start"
            onClick={handleSidebarToggle}
            sx={{
              mr: 2,
              color: theme.palette.text.primary,
              "&:hover": {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.dark,
              },
            }}
          >
            {menutoggle ? (
              <MenuIcon fontSize={isSmallScreen ? "small" : "medium"} />
            ) : (
              <Close fontSize={isSmallScreen ? "small" : "medium"} />
            )}
          </IconButton>
        </Tooltip>

        {/* Cooperative info */}
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          <Avatar src={coOperativeImg} alt="Cooperative" sx={{ width: 40, height: 40, mr: 2 }} />
          <Box>
            <Typography variant="subtitle1" noWrap>
              {coOperativeName} ( {coOperativeCode} )
            </Typography>
            <Typography variant="caption" noWrap>
              {coOperativeAddress}
            </Typography>
          </Box>
        </Box>

        {/* Divider between info & actions */}
        <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />

        {/* Actions */}
        <Box>
          <Tooltip title="Refresh" arrow>
            <IconButton
              onClick={refresh}
              sx={{
                color: theme.palette.primary.main,
                "&:hover": {
                  color: theme.palette.primary.contrastText,
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Logout" arrow>
            <IconButton
              onClick={handleMenuOpen}
              sx={{
                color: theme.palette.error.main,
                "&:hover": {
                  color: theme.palette.error.contrastText,
                  backgroundColor: theme.palette.error.dark,
                },
              }}
            >
              <PowerSettingsNewIcon />
            </IconButton>
          </Tooltip>
        </Box>

        {/* Logout menu */}
        <Menu
          id="logout-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem onClick={handleLogoutClick}>
            <PowerSettingsNewIcon sx={{ mr: 1, color: "error.main" }} /> Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
